let memoizedFuncs = {};

export const Memoize = {
  log() {
    console.log(memoizedFuncs);
  },
  reset(key) {
    memoizedFuncs[key] = [];
  },
  replay(key, reset = false) {
    if (memoizedFuncs[key]) {
      memoizedFuncs[key].forEach(({ args, func }) => {
        func.apply(this, args);
      });
    }
    reset && Memoize.reset(key);
  },
  memoizeFunc(key, func) {
    return function() {
      if (!memoizedFuncs[key]) {
        memoizedFuncs[key] = [];
      }
      const memoized = memoizedFuncs[key];
      const slice = Array.prototype.slice;
      const args = slice.call(arguments);
      console.log('ADDING>...');
      memoized.push({
        func,
        args,
      });
      return func.apply(this, args);
    };
  },
  memoizeCall({ key, func, args }) {
    if (!memoizedFuncs[key]) {
      memoizedFuncs[key] = [];
    }
    const memoized = memoizedFuncs[key];
    memoized.push({
      func,
      args,
    });
    return func.apply(this, args);
  },
};



// WEBPACK FOOTER //
// ./src/socket/memoize.js